import type {PullRequestReviewItem} from '../../../../page-data/payloads/timeline'

function ChangesRequestedReviewText({item}: {item: PullRequestReviewItem}) {
  const {qualifiedReviewer} = item.additionalInfo
  return <>{qualifiedReviewer ? 'requested changes' : 'suggested changes'}</>
}

function DimissedText({item}: {item: PullRequestReviewItem}) {
  const {dismissedState} = item.additionalInfo
  if (dismissedState === 'approved') {
    return <>previously approved these changes</>
  } else if (dismissedState === 'changes_requested') {
    return <>previously requested changes</>
  } else {
    return <>dismissed this review</>
  }
}

const STATE_TEXT = {
  approved: 'approved these changes',
  pending: 'started a review',
  commented: 'reviewed these changes',
}

export function PullRequestReviewText({item}: {item: PullRequestReviewItem}) {
  const {state, reviewerType} = item.additionalInfo

  if (reviewerType === 'code_scanning' || reviewerType === 'automated') {
    return <>found potential problems</>
  }

  if (state === 'dismissed') {
    return <DimissedText item={item} />
  }

  if (state === 'changes_requested') {
    return <ChangesRequestedReviewText item={item} />
  }

  return <>{STATE_TEXT[state] ?? <>reviewed</>}</>
}
